/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalText,GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl,ProductAssetUrl,ParseCategoryIds} from "./../../themes/kent/utilities/constants";

interface IState {
  imageLoaded?:any;
  zoomActive?:any;
}

interface IProps {
  image?: any;
  product?:any;
  year?:any;
}

/**
 *
 * Sizes component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class ZoomableImage extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props:IProps) {
    super(props);
    this.state = {
      zoomActive:false
    };
  }

  componentDidMount = () => {
  }
  onImageLoad =()=>{
    this.setState({
      imageLoaded:true
    })
  }

  public render(): JSX.Element {
    let prodAssetUrl = GenerateProductAssetUrl(this.props.year);
    var image = prodAssetUrl+this.props.image;
    let classAdd = '';
    if(this.state.imageLoaded){
      classAdd = 'active';
    }

    var width = '60%';

    if(this.props.product){
      if(this.props.product.attributes){
        if(this.props.product.attributes.category == ParseCategoryIds.wakeboards){

          width = '50%';
        }
        if(this.props.product.attributes.category == ParseCategoryIds.waterskis){
          if(this.props.product.attributes.subcategory != "ryTmS05B5d" && this.props.product.attributes.subcategory !="wWHALtqszI" && this.props.product.attributes.subcategory != "sfeyr5jKh5"){

            width = '25%';
          }
        }
        if(this.props.product.attributes.category == ParseCategoryIds.wakesurfers && this.props.product.attributes.subcategory != "EYPAnD1L4c"){

          width = '40%';
        }

        if(this.props.product.attributes.subcategory == "sfeyr5jKh5" || this.props.product.attributes.subcategory =="ryTmS05B5d"){

          width = '60%';
        }
      }
    }
    width = "100%";
    return (
      <div style={{alignItems:"center", maxWidth:"1100px", margin:"auto", position:'relative', display:'flex', justifyContent:"center"}}>
        <div className={"full-width zoomable-image-container "+classAdd}>
          <div style={{flex:'1', display:"flex", alignItems:"center", justifyContent:"center"}}>
            <div style={{width:width}}>
              <img className="three-quarter-width zoomable-image" src={image} onLoad={this.onImageLoad} style={{position:'relative'}} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ZoomableImage;
